<div class="containerLogin">
  <div class="image-section">
    <div class="container1">
      <h2 class="title">aims - Ihr Schlüssel zur strategischen Projektexzellenz.</h2>
      <div class="subtitle">
        <h6>
          Mit seiner umfassenden Palette an Funktionen ermöglicht aims eine effektive Umsetzung von <br />
          Strategiemaßnahmen und garantiert eine klare Übersicht aller strategischen <br />
          Unternehmensprojekte.
        </h6>

        <h6>
          Das Tool unterstützt Sie dabei, auf Veränderungen schnell zu reagieren und Risiken zu<br />
          minimieren, um Ihre Projekte erfolgreich abzuschließen.
      
         </h6>
         <h6>
          Stillstand in der Unternehmensentwicklung durch Priorisierung des Tagesgeschäfts <br />
          gehört mit aims der Vergangenheit an.
         
        </h6>
          <h6>
          Erleben Sie mit aims eine neue Dimension des Projektmanagements, <br />
          die Ihre Visionen Wirklichkeit werden lässt.
        </h6>
      </div>
    </div>
    <img src="assets/images/aimsLoginBG.png" />
    <p class="copyright">Impressum © 2024 wissenswerft GmbH</p>
  </div>
  <div class="login-section">
    <img class="image" src="assets/images/aimsLogo.svg" />

    <div id="input-form">
      <h2 class="login-title">Login</h2>
      <abc-authentication-login></abc-authentication-login>
    </div>

    <img class="imageProwredBy" src="assets/images/poweredbywissenswerft.svg" />
  </div>
</div>
